import React, { useId, useState } from 'react';
import './common.css';

const Input = ({ label, type = 'text', value, onChange, error, placeholder, name, id, disabled = false, className = '', onFocus, onBlur, ...inputProps }) => {
  const [focused, setFocused] = useState(false);
  const generatedId = useId();
  const inputId = id || generatedId;
  const errorId = `${inputId}-error`;
  const describedBy = [inputProps['aria-describedby'], error ? errorId : ''].filter(Boolean).join(' ') || undefined;
  
  const inputClass = `neon-input ${error ? 'neon-input-error' : ''} ${focused ? 'focused' : ''} ${disabled ? 'disabled' : ''}`;

  return (
    <div className="neon-input-container">
      {label && <label className="neon-input-label" htmlFor={inputId}>{label}</label>}
      <div className="neon-input-wrapper">
        <input
          {...inputProps}
          id={inputId}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onFocus={event => { setFocused(true); onFocus?.(event); }}
          onBlur={event => { setFocused(false); onBlur?.(event); }}
          placeholder={placeholder}
          disabled={disabled}
          className={`${inputClass} ${className}`.trim()}
          aria-invalid={error ? true : inputProps['aria-invalid']}
          aria-describedby={describedBy}
        />
        <div className={`neon-input-glow ${focused ? 'visible' : ''}`}></div>
      </div>
      {error && (
        <p id={errorId} className="neon-input-error-message">
          <span>⚠</span>
          {error}
        </p>
      )}
    </div>
  );
};

export default Input;
